<template>
  <div class="box">
    <div ref="chart" id="piechart2"></div>
  </div>
</template>
 
<script>
// import echarts from "echarts";
 
export default {
  name: "piechart2",
  props: {
    charData: {
      type: Object
    },
    charTitle: {
      type: String
    }
  },
  data() {
    return {
      chart: null,
      pieData: []
    };
  },
  watch: {
    charData: {
      handler() {
        this.renderChart();
      },
      deep: true
    }
  },
  mounted() {
    // 在组件mounted时绑定resize事件，当窗口大小发生变化时自动调整图表大小
    window.addEventListener("resize", this.handleResize);
    // 创建Echarts实例并绘制饼状图
    this.creatCharts();
  },
  beforeDestroy() {
    // 在组件销毁前解绑resize事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    async creatCharts() {
      this.renderChart();
    },
    // 处理resize事件，调整图表大小
    handleResize() {
      if (this.chart) {
        // 调用Echarts实例的resize方法，重新绘制图表
        this.chart.resize();
      }
    },
    renderChart() {
      let chart = this.$echarts.init(document.getElementById("piechart2")); //document.getElementById("piechart") //this.$refs.chart
      let option;
      
      // option = {
      //         title: {
      //                   // 设置饼图标题，位置设为顶部居中
      //                   text: "国内院士前五省份图示",
      //                   top: "0%",
      //                   left: "center"
      //                 },
      //         series: [
      //           {
      //             type: "pie", // type设置为饼图
      //             data: [
      //               {
      //                 value: 463,
      //                 name: "江苏"
      //               },
      //               {
      //                 value: 395,
      //                 name: "浙江"
      //               },
      //               {
      //                 value: 157,
      //                 name: "山东"
      //               },
      //               {
      //                 value: 149,
      //                 name: "广东"
      //               },
      //               {
      //                 value: 147,
      //                 name: "湖南"
      //               }
      //             ]
      //           }
      //         ]
      //       };

      
      if (this.charData.length > 0) {
        option = {
          title: {
            text: this.charTitle,
            textStyle: {
              fontWeight: "normal",
              fontSize: 16
            },
            left: "center"
          },
          color: ["#6395F9", "#62DAAB", "#657798", "#F6C022", "#E96C5B", "#74CBED", "#9968BD", "#FF9D4E", "#299998"],
          tooltip: {
            trigger: "item",
            formatter: "{b}：{d}%"
          },
          series: [
            {
              type: "pie",
              radius: ["60%", "90%"],
              top: 6,
              bottom: 25,
              left: "center",
              textStyle: {
                color: "#999",
                fontSize: "12px"
              },
              itemWidth: 6,
              itemHeight: 6,
              label: {
                show: true,
                formatter: "{b}: {d}%"
              },
              data: this.charData
            }
          ]
        };
      } else {
        option = {
          title: {
            text: this.charTitle,
            textStyle: {
              fontWeight: "normal",
              fontSize: 16
            },
            left: "center"
          },
          tooltip: {
            trigger: "none"
          },
          color: ["#d3d3d3"],
          series: [
            {
              type: "pie",
              radius: ["60%", "90%"],
              left: "center",
              label: {
                show: true,
                formatter: "{b}"
              },
              data: [{ value: 1, name: "暂无数据" }]
            }
          ]
        };
      }
 
      chart.setOption(option);
      this.chart = chart;
    }
  }
};
</script>
<style scoped>
.box {
  width: 100%;
  height: 100%;
}
#piechart2 {
  width: 100%;
  height: 100%;
}
</style>